export enum BlogType {
  home = "154,155,15,16",
  myfuelcardaccount = "155",
  mybusinessadvantage = "15",
  mydriversclub = "154",
  myfleetsolutions = "16"
}



// WEBPACK FOOTER //
// ./src/app/genericpages/blogtypes.ts